/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgFluentOutlookFilled = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.24 7.616 9.2 4.736h-.072a.632.632 0 0 0-.296-.112.688.688 0 0 0-.312.072h-.072l-5.04 2.88a.304.304 0 0 0-.152.272.312.312 0 0 0 .144.264L8.832 12l5.448-3.848a.32.32 0 0 0 .152-.264.312.312 0 0 0-.192-.272Z",
        fill: "#0A2767"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.832 1.6h-8a.8.8 0 0 0-.8.8l4.8 1.6 4.8-1.6a.8.8 0 0 0-.8-.8Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.8 2.4H4v4.8l4.792 4.808h4.8V7.192L8.8 2.4Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.6 2.4H8.8v4.8h4.8V2.4Z",
        fill: "#50D9FF"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.792 12.008 4 12V7.2h4.8l-.008 4.808Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: 0.5,
        d: "M8.832 12 3.368 8.136l.408-.704 5.056 2.864 5.024-2.872.392.728L8.832 12Z",
        fill: "#0A2767"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M14.248 8.152 9.2 11.024a.712.712 0 0 1-.376.112h-.048a.836.836 0 0 1-.2 0l1.856 2.464 3.712.664a.704.704 0 0 0 .288-.568V7.888a.32.32 0 0 1-.184.264Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: 0.1,
        d: "m9.632 10.784-.432.248a.713.713 0 0 1-.376.112h-.048a.836.836 0 0 1-.2 0l1.856 2.456 3.712.664a.704.704 0 0 0 .288-.568v-.216l-4.8-2.696Z",
        fill: "#000"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.344 8.152a.312.312 0 0 1-.112-.264v5.816a.696.696 0 0 0 .464.656.747.747 0 0 0 .232 0h9.768a.688.688 0 0 0 .408-.128l-10.76-6.08Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: 0.5,
        d: "M8.832 12.8a1.6 1.6 0 0 0 1.6-1.6V5.6a.8.8 0 0 0-.8-.8h-5.6v2.456l-.632.36a.32.32 0 0 0-.152.264h-.016v4.912l5.6.008Z",
        fill: "#000"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.8 4H2.4a.8.8 0 0 0-.8.8v6.4a.8.8 0 0 0 .8.8h6.4a.8.8 0 0 0 .8-.8V4.8a.8.8 0 0 0-.8-.8Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.36 6.696a2.176 2.176 0 0 1 .888-.936 2.808 2.808 0 0 1 1.384-.336 2.576 2.576 0 0 1 1.312.32c.383.2.698.509.904.888a2.808 2.808 0 0 1 .304 1.312A2.928 2.928 0 0 1 7.84 9.32a2.256 2.256 0 0 1-.896.904 2.736 2.736 0 0 1-1.36.328 2.696 2.696 0 0 1-1.344-.328 2.256 2.256 0 0 1-.88-.896 2.768 2.768 0 0 1-.304-1.296 2.96 2.96 0 0 1 .304-1.336Zm.952 2.184a1.36 1.36 0 0 0 .496.616 1.352 1.352 0 0 0 .8.224 1.408 1.408 0 0 0 .8-.232 1.328 1.328 0 0 0 .488-.616 2.24 2.24 0 0 0 .152-.856 2.512 2.512 0 0 0-.144-.864 1.296 1.296 0 0 0-1.272-.88 1.4 1.4 0 0 0-.8.224 1.44 1.44 0 0 0-.512.616A2.12 2.12 0 0 0 4.144 8c-.01.302.048.602.168.88Z",
        fill: "#fff"
    }));
export default SvgFluentOutlookFilled;
